module.exports = __webpack_public_path__ + "img/script-task.82657b4f.svg";